import { IS_BUSY, SetIsBusyAction } from './actions'

export const actionCreators = {
    setIsBusy: (isBusy: boolean, isBusyLabel: string) => ({ type: IS_BUSY, isBusy, isBusyLabel } as SetIsBusyAction)
}
